var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";
import { handleError, FTLPathUtils, FTLObjectUtils, } from "../..";
import { localStoreStorage } from "../lib";
import { changeLocationAction, setProfileAction } from "../lib/actions";
import { initialFilters, initialProfile, initialTableSettings, } from "../lib/reducers/initialState";
const resetStorage = () => {
    const keysToReset = localStoreStorage.get("currentLocalStores");
    if (keysToReset) {
        keysToReset.forEach((key) => {
            const item = localStoreStorage.get(key);
            if (item) {
                localStoreStorage.set(key, {
                    filters: initialFilters,
                    tableSettings: Object.assign(Object.assign({}, initialTableSettings), { pageSize: item.tableSettings.pageSize, columnOrder: item.tableSettings.columnOrder, hiddenColumns: item.tableSettings.hiddenColumns }),
                });
            }
        });
    }
    localStoreStorage.set("currentLocalStores", "");
};
/**
 * @category Components
 */
export const StoreProvider = ({ children, getProfile, store, }) => {
    const location = useLocation();
    const dispatch = store.dispatch;
    const [canFetchProfile, setCanFetchProfile] = useState(true);
    const firstRender = useRef(true);
    const currentPath = useMemo(() => FTLPathUtils.pathToArray(location.pathname)[0], [location.pathname]);
    const fetchProfile = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (getProfile)
            try {
                const profile = (yield getProfile()).data.result;
                dispatch(setProfileAction(profile));
                setCanFetchProfile(true);
            }
            catch (error) {
                setCanFetchProfile(false);
                if (false) {
                    // TODO что бы вернуться к этому потом
                    handleError({
                        error,
                        defaultError: "Произошла ошибка при получении данных профиля",
                    });
                }
            }
    }), [dispatch, getProfile]);
    useEffect(() => {
        const state = store.getState();
        if (!firstRender.current && currentPath) {
            resetStorage();
            dispatch(changeLocationAction);
        }
        firstRender.current = false;
        if (currentPath === "profile" ||
            (FTLObjectUtils.compare(state.globalStore.profile, initialProfile) &&
                currentPath &&
                canFetchProfile))
            fetchProfile();
    }, [currentPath]);
    return React.createElement(Provider, { store: store }, children);
};
export default StoreProvider;
//# sourceMappingURL=StoreProvider.js.map